enum LoadError {
    NETWORK_NO_SOURCE = 'NETWORK_NO_SOURCE',
    CERTIFICATE_REQUEST_FAILED = 'CERTIFICATE_REQUEST_FAILED',
    LICENSE_REQUEST_FAILED = 'LICENSE_REQUEST_FAILED',
    INVALID_LICENSE = 'INVALID_LICENSE',
    WEBKIT_KEY_ERROR = 'WEBKIT_KEY_ERROR',
    BAD_REQUEST = '400',
    NOT_AUTHORIZED = '401',
    FORBIDDEN = '403'
}

export default LoadError;